/**
 * Transaction process graph for practitioner marketing campaigns:
 *   - soulwise-practitioner-campaign
 */

export const transitions = {
  SEND_CAMPAIGN: 'transition/send-campaign',
  SEND_CAMPAIGN_SILENT: 'transition/send-campaign-silent',
};

export const states = {
  INITIAL: 'initial',
  SENT: 'sent',
};

export const graph = {
  id: 'soulwise-practitioner-campaign/release-1',
  initial: states.INITIAL,
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.SEND_CAMPAIGN]: states.SENT,
        [transitions.SEND_CAMPAIGN_SILENT]: states.SENT,
      },
    },
    [states.SENT]: { type: 'final' },
  },
};

export const isRelevantPastTransition = () => false;
export const isCustomerReview = () => false;
export const isProviderReview = () => false;
export const isPrivileged = transition =>
  transition === transitions.SEND_CAMPAIGN || transition === transitions.SEND_CAMPAIGN_SILENT;
export const isCompleted = () => false;
export const isRefunded = () => false;
export const statesNeedingProviderAttention = [];
